import { useContext, useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { AuthContext } from "../../../contexts/AuthContext";
import { tempUrl } from "../../../contexts/ContextProvider";
import { Colors } from "../../../constants/styles";
import { Loader, SearchBar } from "../../../components";
import { addDays, diffDays } from "../../../constants/helper";
import { Container, Card, Form, Row, Col } from "react-bootstrap";
import {
  Box,
  Alert,
  ButtonGroup,
  Button,
  Snackbar,
  Typography,
  Dialog,
  DialogTitle,
  DialogActions,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Autocomplete,
  TextField,
  Paper,
  Pagination,
  FormControlLabel,
  Checkbox,
  DialogContent,
} from "@mui/material";
import DatePicker from "react-datepicker";
import { makeStyles } from "@mui/styles";
import SaveIcon from "@mui/icons-material/Save";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import EditIcon from "@mui/icons-material/Edit";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import SearchIcon from "@mui/icons-material/Search";
import { NumericFormat } from "react-number-format";
import useScreenWidth from "../../../hooks/useScreenWidth";

const useStyles = makeStyles({
  root: {
    "& .MuiTableCell-head": {
      color: "white",
      backgroundColor: Colors.blue700,
    },
  },
  tableRightBorder: {
    borderWidth: 0,
    borderRightWidth: 1,
    borderColor: "white",
    borderStyle: "solid",
  },
});

const TambahPembelian = () => {
  const screenSize = useScreenWidth();
  const { user, setting, dispatch } = useContext(AuthContext);
  const [open, setOpen] = useState(false);
  const [openUbah, setOpenUbah] = useState(false);
  const [validated, setValidated] = useState(false);
  const [isPembelianSaved, setIsPembelianSaved] = useState(false);
  const [isInputStok, setIsInputStok] = useState(false);
  const [pembelianId, setPembelianId] = useState(null);

  // Data Pembelian
  const [noNotaPembelian, setNoNotaPembelian] = useState("");
  const [tglPembelian, setTglPembelian] = useState(
    new Date(user.tutupperiode.dariTanggal)
  );
  const [jumlahItem, setJumlahItem] = useState("0");

  // Data Supplier
  const [kodeSupplier, setKodeSupplier] = useState("");
  const [namaSupplier, setNamaSupplier] = useState("");
  const [alamatSupplier, setAlamatSupplier] = useState("");
  const [kodeCOA, setKodeCOA] = useState("");
  const [keterangan, setKeterangan] = useState("");

  // Data Total
  const [subtotal, setSubtotal] = useState("0");
  const [potongan, setPotongan] = useState("0");
  const [isPpn, setIsPpn] = useState(false);
  const [ppnPersen, setPpnPersen] = useState("0");
  const [ppnTotal, setPpnTotal] = useState("0");
  const [total, setTotal] = useState("0");

  // Data Pembelian Kredit
  const [tipePembelian, setTipePembelian] = useState("TUNAI");
  const [lamaKredit, setLamaKredit] = useState("");
  const [tglJatuhTempo, setTglJatuhTempo] = useState(null);

  // Data Pembelian Child
  const [idPembelianChild, setIdPembelianChild] = useState("");
  const [pilihStok, setPilihStok] = useState("");
  const [kodeStok, setKodeStok] = useState("");
  const [namaStok, setNamaStok] = useState("");
  const [quantity, setQuantity] = useState("0");
  const [hargaSatuan, setHargaSatuan] = useState("0");
  const [discountPersen1, setDiscountPersen1] = useState("0");
  const [discount1, setDiscount1] = useState("0");
  const [discountPersen2, setDiscountPersen2] = useState("0");
  const [discount2, setDiscount2] = useState("0");
  const [hargaNetto, setHargaNetto] = useState("0");
  const [totalPembelianChild, setTotalPembelianChild] = useState("0");

  const [pembelianChilds, setPembelianChilds] = useState([]);

  const [coas, setCoas] = useState([]);
  const [error, setError] = useState(false);

  const [suppliers, setSuppliers] = useState([]);
  const [searchTermSupplier, setSearchTermSupplier] = useState("");
  const [openSupplier, setOpenSupplier] = useState(false);

  let [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);
  const [pages, setPages] = useState(0);
  const [rows, setRows] = useState(0);
  const [query, setQuery] = useState("");

  const [stoks, setStoks] = useState([]);
  const [searchTermStok, setSearchTermStok] = useState("");
  const [openStok, setOpenStok] = useState(false);

  let [pageStok, setPageStok] = useState(0);
  const [limitStok, setLimitStok] = useState(10);
  const [pagesStok, setPagesStok] = useState(0);
  const [rowsStok, setRowsStok] = useState(0);
  const [queryStok, setQueryStok] = useState("");

  const navigate = useNavigate();
  const { id } = useParams();
  const [loading, setLoading] = useState(false);

  const classes = useStyles();

  const handleChange = (e, p) => {
    setPage(p - 1);
  };

  const searchData = (e) => {
    e.preventDefault();
    setPage(0);
    setSearchTermSupplier(query);
  };

  const handleClickOpenUbah = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setOpenUbah(true);
  };

  const handleCloseUbah = () => {
    setOpenUbah(false);
    setIdPembelianChild("");
    setKodeStok("");
    setNamaStok("");
    setQuantity("");
    setHargaSatuan("");
    setDiscountPersen1("");
    setDiscount1("");
    setDiscountPersen2("");
    setDiscount2("");
    setHargaNetto("");
    setTotalPembelianChild("");
  };

  const handleClickOpenSupplier = () => {
    setOpenSupplier(true);
  };

  const handleCloseSupplier = () => {
    setOpenSupplier(false);
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  const handleChangeStok = (e, p) => {
    setPageStok(p - 1);
  };

  const searchDataStok = (e) => {
    e.preventDefault();
    setPageStok(0);
    setSearchTermStok(queryStok);
  };

  const handleClickOpenStok = () => {
    setOpenStok(true);
  };

  const handleCloseStok = () => {
    setOpenStok(false);
  };

  const tipePembelianOption = ["TUNAI", "KREDIT"];
  let coaOptions = coas.map((coa) => ({
    label: `${coa.kodeCOA} - ${coa.namaCOA}`,
  }));

  useEffect(() => {
    getPembelianById();
    getCoas();
    findDefaultDate();
  }, []);

  useEffect(() => {
    getSuppliersData();
  }, [page, searchTermSupplier]);

  useEffect(() => {
    getStoksData();
  }, [pageStok, searchTermStok]);

  const getPembelianById = async () => {
    if (id) {
      setIsPembelianSaved(true);
      setIsInputStok(true);
      setPembelianId(id);
      const response = await axios.post(`${tempUrl}/pembelians/${id}`, {
        kodeCabang: user.cabang.id,
        _id: user.id,
        token: user.token,
      });
      // Data Pembelian
      setNoNotaPembelian(response.data.noNotaPembelian);
      setTglPembelian(new Date(response.data.tglPembelian));

      // Data Supplier
      setKodeSupplier(response.data.kodeSupplier);
      setNamaSupplier(response.data.namaSupplier);
      setAlamatSupplier(response.data.alamatSupplier);
      setKodeCOA(
        response.data.coa &&
          `${response.data.coa.kodeCOA} - ${response.data.coa.namaCOA}`
      );

      // Data Total
      setSubtotal(response.data.subtotal);
      setPotongan(response.data.potongan);
      setTotal(response.data.total);
      setPpnTotal(response.data.ppnTotal);

      // Data Pembelian Kredit
      setTipePembelian(response.data.tipePembelian);
      setLamaKredit(response.data.lamaKredit);
      setTglJatuhTempo(
        response.data.tglJatuhTempo
          ? new Date(response.data.tglJatuhTempo)
          : null
      );

      const response2 = await axios.post(
        `${tempUrl}/pembelianChildsByPembelian`,
        {
          pembelianId: response.data.id,
          kodeCabang: user.cabang.id,
          _id: user.id,
          token: user.token,
        }
      );
      setPembelianChilds(response2.data);
      setJumlahItem(response2.data.length);
    }
  };

  const getCoas = async () => {
    const response = await axios.post(`${tempUrl}/coas`, {
      _id: user.id,
      token: user.token,
      kodeCabang: user.cabang.id,
    });
    setCoas(response.data);
  };

  const findDefaultDate = async () => {
    let newPeriodeAwal = new Date(user.tutupperiode.dariTanggal);
    let newPeriodeAkhir = new Date(user.tutupperiode.sampaiTanggal);
    let newToday = new Date();

    let isDateBetween =
      newToday >= newPeriodeAwal && newToday <= newPeriodeAkhir;

    if (isDateBetween) {
      // Default Date Today
      setTglPembelian(new Date());
    }
  };

  const getSuppliersData = async () => {
    const response = await axios.post(
      `${tempUrl}/suppliersPagination?search_query=${searchTermSupplier}&page=${page}&limit=${limit}`,
      {
        _id: user.id,
        token: user.token,
        kodeCabang: user.cabang.id,
      }
    );
    setSuppliers(response.data.suppliers);
    setPage(response.data.page);
    setPages(response.data.totalPage);
    setRows(response.data.totalRows);
  };

  const getSupplierNextKode = async () => {
    const response = await axios.post(`${tempUrl}/supplierNextKode`, {
      _id: user.id,
      token: user.token,
      kodeCabang: user.cabang.id,
    });
    setKodeSupplier(response.data);
  };

  const getStoksData = async () => {
    const response = await axios.post(
      `${tempUrl}/stoksPagination?search_query=${searchTermStok}&page=${pageStok}&limit=${limitStok}`,
      {
        _id: user.id,
        token: user.token,
        kodeCabang: user.cabang.id,
      }
    );
    setStoks(response.data.stoks);
    setPageStok(response.data.page);
    setPagesStok(response.data.totalPage);
    setRowsStok(response.data.totalRows);
  };

  const getFindStok = async (input) => {
    const response = await axios.post(`${tempUrl}/findStok`, {
      input,
      _id: user.id,
      token: user.token,
      kodeCabang: user.cabang.id,
    });
    setKodeStok(response.data.kodeStok);
    setNamaStok(response.data.namaStok);
  };

  const savePembelian = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    const form = e.currentTarget;

    if (pembelianId !== null) {
      setIsInputStok(true);
      setQuantity("0");
      setHargaSatuan("0");
      setDiscountPersen1("0");
      setDiscount1("0");
      setDiscountPersen2("0");
      setDiscount2("0");
      setHargaNetto("0");
      setTotalPembelianChild("0");
      return;
    }

    let tempValidation = form.checkValidity() && kodeSupplier.length !== 0;
    if (tipePembelian === "TUNAI") {
      tempValidation =
        form.checkValidity() &&
        kodeSupplier.length !== 0 &&
        kodeCOA.length !== 0;
    } else {
      tempValidation =
        form.checkValidity() &&
        kodeSupplier.length !== 0 &&
        lamaKredit.length !== 0 &&
        tglJatuhTempo !== null;
    }

    if (tempValidation) {
      // setLoading(true);
      try {
        // setLoading(true);
        let savedPembelian = await axios.post(`${tempUrl}/savePembelian`, {
          dariTanggal: user.tutupperiode.dariTanggal,
          sampaiTanggal: user.tutupperiode.sampaiTanggal,

          // Data Pembelian
          noNotaPembelian,
          tglPembelian,

          // Data Supplier
          kodeSupplier,
          namaSupplier,
          alamatSupplier,
          kodeCOA: kodeCOA.split(" ", 1)[0],

          // Total
          subtotal,
          potongan,
          total,
          ppnTotal,

          // Data Pembelian Kredit
          tipePembelian,
          lamaKredit,
          tglJatuhTempo,

          userIdInput: user.id,
          kodeCabang: user.cabang.id,
          _id: user.id,
          token: user.token,
        });
        setIsPembelianSaved(true);
        setIsInputStok(true);
        // setLoading(false);
        setPembelianId(savedPembelian.data.id);
        navigate(
          `/daftarPembelian/pembelian/tambahPembelian/${savedPembelian.data.id}`
        );
      } catch (error) {
        alert(error.response.data.message);
      }
      // setLoading(false);
    } else {
      setError(true);
      setOpen(!open);
    }
    setValidated(true);
  };

  const savePembelianChild = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    const form = e.currentTarget;
    if (
      form.checkValidity() &&
      kodeStok.length !== 0 &&
      quantity.length !== 0 &&
      discountPersen1.length !== 0 &&
      discount1.length !== 0 &&
      discountPersen2.length !== 0 &&
      discount2.length !== 0
    ) {
      // setLoading(true);
      try {
        // setLoading(true);
        let savedPembelianChild = await axios.post(
          `${tempUrl}/savePembelianChild`,
          {
            // Data Pembelian Child
            pembelianId,
            kodeStok,
            namaStok,
            quantity,
            hargaSatuan,
            discountPersen1,
            discount1,
            discountPersen2,
            discount2,
            hargaNetto,
            totalPembelianChild,

            userIdInput: user.id,
            kodeCabang: user.cabang.id,
            _id: user.id,
            token: user.token,
          }
        );
        setIsInputStok(false);

        // Data Pembelian Child
        setPilihStok("");
        setKodeStok("");
        setNamaStok("");
        setQuantity("");
        setHargaSatuan("");
        setDiscountPersen1("");
        setDiscount1("");
        setDiscountPersen2("");
        setDiscount2("");
        setHargaNetto("");
        setTotalPembelianChild("");

        let findPembelianChild = await axios.post(
          `${tempUrl}/pembelianChildsByPembelian`,
          {
            pembelianId,
            _id: user.id,
            token: user.token,
            kodeCabang: user.cabang.id,
          }
        );
        setPembelianChilds(findPembelianChild.data);
        setJumlahItem(findPembelianChild.data.length);

        let findPembelian = await axios.post(
          `${tempUrl}/pembelians/${pembelianId}`,
          {
            _id: user.id,
            token: user.token,
            kodeCabang: user.cabang.id,
          }
        );
        setSubtotal(findPembelian.data.subtotal);
        setTotal(findPembelian.data.subtotal);
      } catch (error) {
        alert(error.response.data.message);
      }
      // setLoading(false);
    } else {
      setError(true);
      setOpen(!open);
    }
    setValidated(true);
  };

  const updatePembelianChild = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    const form = e.currentTarget;
    if (
      form.checkValidity() &&
      kodeStok.length !== 0 &&
      quantity.length !== 0 &&
      discountPersen1.length !== 0 &&
      discount1.length !== 0 &&
      discountPersen2.length !== 0 &&
      discount2.length !== 0
    ) {
      // setLoading(true);
      try {
        // setLoading(true);
        let savedPembelianChild = await axios.post(
          `${tempUrl}/updatePembelianChild/${idPembelianChild}`,
          {
            // Data Pembelian Child
            pembelianId,
            kodeStok,
            namaStok,
            quantity,
            hargaSatuan,
            discountPersen1,
            discount1,
            discountPersen2,
            discount2,
            hargaNetto,
            totalPembelianChild,

            userIdInput: user.id,
            kodeCabang: user.cabang.id,
            _id: user.id,
            token: user.token,
          }
        );
        setIsInputStok(false);

        // Data Pembelian Child
        setPilihStok("");
        setKodeStok("");
        setNamaStok("");
        setQuantity("");
        setHargaSatuan("");
        setDiscountPersen1("");
        setDiscount1("");
        setDiscountPersen2("");
        setDiscount2("");
        setHargaNetto("");
        setTotalPembelianChild("");

        let findPembelianChild = await axios.post(
          `${tempUrl}/pembelianChildsByPembelian`,
          {
            pembelianId,
            _id: user.id,
            token: user.token,
            kodeCabang: user.cabang.id,
          }
        );
        setPembelianChilds(findPembelianChild.data);
        setJumlahItem(findPembelianChild.data.length);

        let findPembelian = await axios.post(
          `${tempUrl}/pembelians/${pembelianId}`,
          {
            _id: user.id,
            token: user.token,
            kodeCabang: user.cabang.id,
          }
        );
        setSubtotal(findPembelian.data.subtotal);
        setPotongan("0");
        setPpnPersen("0");
        setPpnTotal("0");
        setTotal(findPembelian.data.subtotal);

        handleCloseUbah();
      } catch (error) {
        alert(error.response.data.message);
      }
      // setLoading(false);
    } else {
      setError(true);
      setOpen(!open);
    }
    setValidated(true);
  };

  const deletePembelianChild = async (e, id, totalPembelianChild) => {
    e.preventDefault();
    e.stopPropagation();

    const confirmed = window.confirm("Yakin ingin menghapus barang ini?");
    if (!confirmed) return;

    const form = e.currentTarget;
    if (form.checkValidity()) {
      // setLoading(true);
      try {
        // setLoading(true);
        let deletedPembelianChild = await axios.post(
          `${tempUrl}/deletePembelianChild/${id}`,
          {
            // Data Pembelian Child
            pembelianId,
            totalPembelianChild,

            kodeCabang: user.cabang.id,
            _id: user.id,
            token: user.token,
          }
        );
        setIsInputStok(false);

        let findPembelianChild = await axios.post(
          `${tempUrl}/pembelianChildsByPembelian`,
          {
            pembelianId,
            _id: user.id,
            token: user.token,
            kodeCabang: user.cabang.id,
          }
        );
        setPembelianChilds(findPembelianChild.data);
        setJumlahItem(findPembelianChild.data.length);

        let findPembelian = await axios.post(
          `${tempUrl}/pembelians/${pembelianId}`,
          {
            _id: user.id,
            token: user.token,
            kodeCabang: user.cabang.id,
          }
        );
        setSubtotal(findPembelian.data.subtotal);
        setPotongan("0");
        setPpnPersen("0");
        setPpnTotal("0");
        setTotal(findPembelian.data.subtotal);
      } catch (error) {
        alert(error.response.data.message);
      }
      // setLoading(false);
    } else {
      setError(true);
      setOpen(!open);
    }
    setValidated(true);
  };

  const savePembelianTotal = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    const form = e.currentTarget;

    let tempValidation = form.checkValidity();

    if (tipePembelian === "KREDIT") {
      tempValidation =
        form.checkValidity() &&
        lamaKredit.length !== 0 &&
        tglJatuhTempo !== null;
    }

    if (tempValidation) {
      // setLoading(true);
      try {
        // setLoading(true);
        let updatedPembelian = await axios.post(
          `${tempUrl}/updatePembelianTotal/${pembelianId}`,
          {
            tglPembelian,
            // Total
            subtotal,
            potongan,
            total,
            ppnPersen,
            ppnTotal,

            // Data Pembelian Kredit
            tipePembelian,
            lamaKredit,
            tglJatuhTempo,

            userIdInput: user.id,
            kodeCabang: user.cabang.id,
            _id: user.id,
            token: user.token,
          }
        );
        navigate(`/daftarPembelian`);
      } catch (error) {
        alert(error.response.data.message);
      }
      // setLoading(false);
    } else {
      setError(true);
      setOpen(!open);
    }
    setValidated(true);
  };

  if (loading) {
    return <Loader />;
  }

  const textRight = {
    textAlign: screenSize >= 650 && "right",
  };

  return (
    <Container>
      <h3>Transaksi</h3>
      <h5 style={{ fontWeight: 400 }}>Tambah Pembelian</h5>
      <Typography sx={subTitleText}>
        Periode : {user.tutupperiode.namaPeriode}
      </Typography>
      <hr />
      <Form noValidate validated={validated} onSubmit={savePembelian}>
        <Card>
          <Card.Header>Data Pembelian</Card.Header>
          <Card.Body>
            <Box sx={textFieldContainer}>
              <Box sx={textFieldWrapper}>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        No. Nota{" "}
                        {isPembelianSaved === false ? (
                          <>
                            <b style={colorRed}>*</b>
                            {" :"}
                          </>
                        ) : (
                          ":"
                        )}
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          required
                          value={noNotaPembelian}
                          onChange={(e) => {
                            setNoNotaPembelian(e.target.value);
                          }}
                          disabled={isPembelianSaved && true}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Tanggal{" "}
                        {isPembelianSaved === false ? (
                          <>
                            <b style={colorRed}>*</b>
                            {" :"}
                          </>
                        ) : (
                          ":"
                        )}
                      </Form.Label>
                      <Col sm="7">
                        <DatePicker
                          required
                          dateFormat="dd/MM/yyyy"
                          selected={tglPembelian}
                          minDate={new Date(user.tutupperiode.dariTanggal)}
                          maxDate={new Date(user.tutupperiode.sampaiTanggal)}
                          customInput={<Form.Control required />}
                          onChange={(date) => {
                            setTglPembelian(date);
                          }}
                          disabled={isPembelianSaved && true}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Jumlah Item :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          required
                          value={jumlahItem}
                          disabled
                          readOnly
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
              </Box>
              <Box sx={[textFieldWrapper, secondWrapper]}></Box>
            </Box>
          </Card.Body>
        </Card>

        <Card style={{ marginTop: 10 }}>
          <Card.Header>Data Supplier</Card.Header>
          <Card.Body>
            <Box sx={textFieldContainer}>
              <Box sx={textFieldWrapper}>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Kode Supplier{" "}
                        {isPembelianSaved === false ? (
                          <>
                            <b style={colorRed}>*</b>
                            {" :"}
                          </>
                        ) : (
                          ":"
                        )}
                      </Form.Label>
                      <Col sm="5">
                        <Form.Control
                          value={kodeSupplier}
                          style={{ textTransform: "uppercase" }}
                          disabled
                        />
                      </Col>
                      <Col sm="2">
                        <Button
                          variant="contained"
                          onClick={() => handleClickOpenSupplier()}
                          disabled={isPembelianSaved && true}
                        >
                          <SearchIcon />
                        </Button>
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Nama :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          value={namaSupplier}
                          style={{ textTransform: "uppercase" }}
                          disabled
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Alamat :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          as="textarea"
                          rows={3}
                          value={alamatSupplier}
                          style={{ textTransform: "uppercase" }}
                          disabled
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
              </Box>
              <Box sx={[textFieldWrapper, secondWrapper]}>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Tipe Pembelian{" "}
                        {isPembelianSaved === false ? (
                          <>
                            <b style={colorRed}>*</b>
                            {" :"}
                          </>
                        ) : (
                          ":"
                        )}
                      </Form.Label>
                      <Col sm="7">
                        <Form.Select
                          required
                          value={tipePembelian}
                          onChange={(e) => {
                            setTipePembelian(e.target.value);

                            if (e.target.value === "TUNAI") {
                              setLamaKredit("");
                              setTglJatuhTempo(null);
                            } else {
                              setKodeCOA("");
                            }
                          }}
                          disabled={isPembelianSaved && true}
                        >
                          {tipePembelianOption.map((tipePembelian) => (
                            <option value={tipePembelian}>
                              {tipePembelian}
                            </option>
                          ))}
                        </Form.Select>
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Lama Kredit{" "}
                        {tipePembelian === "KREDIT" &&
                        isPembelianSaved === false ? (
                          <>
                            <b style={colorRed}>*</b>
                            {" :"}
                          </>
                        ) : (
                          ":"
                        )}
                      </Form.Label>
                      <Col sm="7">
                        <NumericFormat
                          required={tipePembelian === "KREDIT" && true}
                          value={lamaKredit}
                          decimalSeparator={","}
                          thousandSeparator={"."}
                          customInput={Form.Control}
                          onValueChange={(values) => {
                            let tempValue = values.formattedValue
                              .split(".")
                              .join("")
                              .replace(/,/g, "");
                            setLamaKredit(tempValue);

                            let tempTglJatuhTempo = addDays(
                              tglPembelian,
                              parseInt(tempValue)
                            );
                            setTglJatuhTempo(tempTglJatuhTempo);
                          }}
                          disabled={
                            isPembelianSaved ||
                            (tipePembelian !== "KREDIT" && true)
                          }
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Tgl. Jatuh Tempo{" "}
                        {tipePembelian === "KREDIT" &&
                        isPembelianSaved === false ? (
                          <>
                            <b style={colorRed}>*</b>
                            {" :"}
                          </>
                        ) : (
                          ":"
                        )}
                      </Form.Label>
                      <Col sm="7">
                        <DatePicker
                          required={tipePembelian === "KREDIT" && true}
                          dateFormat="dd/MM/yyyy"
                          selected={tglJatuhTempo}
                          customInput={<Form.Control required />}
                          onChange={(date) => {
                            setTglJatuhTempo(date);

                            let tempLamaKredit = diffDays(tglPembelian, date);
                            setLamaKredit(tempLamaKredit);
                          }}
                          disabled={
                            isPembelianSaved ||
                            (tipePembelian !== "KREDIT" && true)
                          }
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Kode Kas{" "}
                        {isPembelianSaved === false &&
                        tipePembelian === "TUNAI" ? (
                          <>
                            <b style={colorRed}>*</b>
                            {" :"}
                          </>
                        ) : (
                          ":"
                        )}
                      </Form.Label>
                      <Col sm="7">
                        <Autocomplete
                          size="small"
                          disablePortal
                          id="combo-box-demo"
                          options={coaOptions}
                          renderInput={(params) => (
                            <TextField
                              error={error && kodeCOA.length === 0 && true}
                              size="small"
                              {...params}
                            />
                          )}
                          onChange={(e, value) => {
                            if (value) {
                              setKodeCOA(value.label);
                            } else {
                              setKodeCOA("");
                            }
                          }}
                          value={kodeCOA}
                          disabled={
                            isPembelianSaved ||
                            (tipePembelian === "KREDIT" && true)
                          }
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Catatan :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          as="textarea"
                          rows={3}
                          value={keterangan}
                          onChange={(e) => {
                            setKeterangan(e.target.value);
                          }}
                          style={{ textTransform: "uppercase" }}
                          disabled={isPembelianSaved && true}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
              </Box>
            </Box>
          </Card.Body>
        </Card>

        <Box sx={spacingTop}>
          <Button
            variant="contained"
            color="info"
            sx={{
              bgcolor: "info.light",
              textTransform: "none",
              marginRight: 2,
              marginBottom: 2,
            }}
            type="submit"
          >
            {"+ Input Transaksi"}
          </Button>
        </Box>
      </Form>

      <Form noValidate validated={validated} onSubmit={savePembelianChild}>
        <Card style={{ marginTop: 10 }}>
          <Card.Header>Detail Transaksi</Card.Header>
          <Card.Body>
            <Box sx={textFieldContainer}>
              <Box sx={textFieldWrapper}>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Kode / Barcode{" "}
                        {isInputStok === true ? (
                          <>
                            <b style={colorRed}>*</b>
                            {" :"}
                          </>
                        ) : (
                          ":"
                        )}
                      </Form.Label>
                      <Col sm="5">
                        <Form.Control
                          required
                          value={pilihStok}
                          onChange={(e) => {
                            setPilihStok(e.target.value);
                          }}
                          onKeyDown={(e) => {
                            if (e.key === "Enter") {
                              e.preventDefault();
                              // alert("Enter pressed on kodeStok");
                              getFindStok(e.target.value);
                            }
                          }}
                          style={{ textTransform: "uppercase" }}
                          disabled={isInputStok === true ? false : true}
                        />
                      </Col>
                      <Col sm="2">
                        <Button
                          variant="contained"
                          onClick={() => handleClickOpenStok()}
                          disabled={isInputStok === true ? false : true}
                        >
                          <SearchIcon />
                        </Button>
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Nama Stok :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control disabled value={namaStok} />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Quantity{" "}
                        {isInputStok === true ? (
                          <>
                            <b style={colorRed}>*</b>
                            {" :"}
                          </>
                        ) : (
                          ":"
                        )}
                      </Form.Label>
                      <Col sm="7">
                        <NumericFormat
                          required
                          value={quantity}
                          decimalSeparator={","}
                          thousandSeparator={"."}
                          customInput={Form.Control}
                          onValueChange={(values) => {
                            let tempValue = values.formattedValue
                              .split(".")
                              .join("")
                              .replace(/,/g, "");
                            setQuantity(tempValue);

                            let tempHargaNetto =
                              parseFloat(hargaSatuan) -
                              parseFloat(discount1) -
                              parseFloat(discount2);
                            setHargaNetto(tempHargaNetto);

                            let tempTotalPembelianChild =
                              parseFloat(tempValue) *
                              parseFloat(tempHargaNetto);
                            setTotalPembelianChild(tempTotalPembelianChild);
                          }}
                          disabled={isInputStok === true ? false : true}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Harga Satuan{" "}
                        {isInputStok === true ? (
                          <>
                            <b style={colorRed}>*</b>
                            {" :"}
                          </>
                        ) : (
                          ":"
                        )}
                      </Form.Label>
                      <Col sm="7">
                        <NumericFormat
                          required
                          value={hargaSatuan}
                          decimalSeparator={","}
                          thousandSeparator={"."}
                          customInput={Form.Control}
                          onValueChange={(values) => {
                            let tempValue = values.formattedValue
                              .split(".")
                              .join("")
                              .replace(/,/g, "");
                            setHargaSatuan(tempValue);

                            let tempHargaNetto =
                              parseFloat(tempValue) -
                              parseFloat(discount1) -
                              parseFloat(discount2);
                            setHargaNetto(tempHargaNetto);

                            let tempTotalPembelianChild =
                              parseFloat(quantity) * parseFloat(tempHargaNetto);
                            setTotalPembelianChild(tempTotalPembelianChild);

                            let tempDiscount1 =
                              (parseFloat(tempValue) * discountPersen1) / 100;
                            setDiscount1(tempDiscount1);

                            let tempDiscount2 =
                              ((parseFloat(tempValue) -
                                parseFloat(tempDiscount1)) *
                                discountPersen2) /
                              100;
                            setDiscount2(tempDiscount2);
                          }}
                          disabled={isInputStok === true ? false : true}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Disc / Pot. 1{" "}
                        {isInputStok === true ? (
                          <>
                            <b style={colorRed}>*</b>
                            {" :"}
                          </>
                        ) : (
                          ":"
                        )}
                      </Form.Label>
                      <Col sm="3">
                        <NumericFormat
                          required
                          value={discountPersen1}
                          decimalSeparator={","}
                          thousandSeparator={"."}
                          customInput={Form.Control}
                          onValueChange={(values, sourceInfo) => {
                            if (sourceInfo.source !== "event") return;

                            let tempValue = values.formattedValue;
                            setDiscountPersen1(tempValue);

                            let tempDiscount1 =
                              (parseFloat(hargaSatuan) * tempValue) / 100;
                            setDiscount1(tempDiscount1);

                            let temHargaNetto =
                              parseFloat(hargaSatuan) -
                              parseFloat(tempDiscount1);
                            setHargaNetto(temHargaNetto);

                            let tempTotalPembelianChild =
                              parseFloat(quantity) * parseFloat(temHargaNetto);
                            setTotalPembelianChild(tempTotalPembelianChild);

                            let tempDiscount2 =
                              ((parseFloat(hargaSatuan) -
                                parseFloat(tempDiscount1)) *
                                discountPersen2) /
                              100;
                            setDiscount2(tempDiscount2);
                          }}
                          disabled={isInputStok === true ? false : true}
                        />
                      </Col>
                      <Col sm="4">
                        <NumericFormat
                          required
                          value={discount1}
                          decimalSeparator={","}
                          thousandSeparator={"."}
                          customInput={Form.Control}
                          onValueChange={(values, sourceInfo) => {
                            if (sourceInfo.source !== "event") return;
                            let tempValue = values.formattedValue
                              .split(".")
                              .join("")
                              .replace(/,/g, "");
                            setDiscount1(tempValue);

                            let tempDiscountPersen1 =
                              (parseFloat(tempValue) /
                                parseFloat(hargaSatuan)) *
                              100;
                            // limit to 2 decimals
                            tempDiscountPersen1 = Number(
                              tempDiscountPersen1.toFixed(2)
                            );
                            setDiscountPersen1(tempDiscountPersen1);

                            let temHargaNetto =
                              parseFloat(hargaSatuan) - parseFloat(tempValue);
                            setHargaNetto(temHargaNetto);

                            let tempTotalPembelianChild =
                              parseFloat(quantity) * parseFloat(temHargaNetto);
                            setTotalPembelianChild(tempTotalPembelianChild);
                          }}
                          disabled={isInputStok === true ? false : true}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Disc / Pot. 2{" "}
                        {isInputStok === true ? (
                          <>
                            <b style={colorRed}>*</b>
                            {" :"}
                          </>
                        ) : (
                          ":"
                        )}
                      </Form.Label>
                      <Col sm="3">
                        <NumericFormat
                          required
                          value={discountPersen2}
                          decimalSeparator={","}
                          thousandSeparator={"."}
                          customInput={Form.Control}
                          onValueChange={(values, sourceInfo) => {
                            if (sourceInfo.source !== "event") return;

                            let tempValue = values.formattedValue;
                            setDiscountPersen2(tempValue);

                            let tempDiscount2 =
                              ((parseFloat(hargaSatuan) -
                                parseFloat(discount1)) *
                                tempValue) /
                              100;
                            setDiscount2(tempDiscount2);

                            let temHargaNetto =
                              parseFloat(hargaSatuan) -
                              parseFloat(discount1) -
                              parseFloat(tempDiscount2);
                            setHargaNetto(temHargaNetto);

                            let tempTotalPembelianChild =
                              parseFloat(quantity) * parseFloat(temHargaNetto);
                            setTotalPembelianChild(tempTotalPembelianChild);
                          }}
                          disabled={isInputStok === true ? false : true}
                        />
                      </Col>
                      <Col sm="4">
                        <NumericFormat
                          required
                          value={discount2}
                          decimalSeparator={","}
                          thousandSeparator={"."}
                          customInput={Form.Control}
                          onValueChange={(values, sourceInfo) => {
                            if (sourceInfo.source !== "event") return;
                            let tempValue = values.formattedValue
                              .split(".")
                              .join("")
                              .replace(/,/g, "");
                            setDiscount2(tempValue);

                            let tempDiscountPersen2 =
                              (parseFloat(tempValue) /
                                (parseFloat(hargaSatuan) -
                                  parseFloat(discount1))) *
                              100;
                            // limit to 2 decimals
                            tempDiscountPersen2 = Number(
                              tempDiscountPersen2.toFixed(2)
                            );
                            setDiscountPersen2(tempDiscountPersen2);

                            let temHargaNetto =
                              parseFloat(hargaSatuan) -
                              parseFloat(discount1) -
                              parseFloat(tempValue);
                            setHargaNetto(temHargaNetto);

                            let tempTotalPembelianChild =
                              parseFloat(quantity) * parseFloat(temHargaNetto);
                            setTotalPembelianChild(tempTotalPembelianChild);
                          }}
                          disabled={isInputStok === true ? false : true}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Harga Netto :
                      </Form.Label>
                      <Col sm="7">
                        <NumericFormat
                          disabled
                          value={hargaNetto}
                          decimalSeparator={","}
                          thousandSeparator={"."}
                          customInput={Form.Control}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Total :
                      </Form.Label>
                      <Col sm="7">
                        <NumericFormat
                          disabled
                          value={totalPembelianChild}
                          decimalSeparator={","}
                          thousandSeparator={"."}
                          customInput={Form.Control}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
              </Box>
              <Box sx={[textFieldWrapper, secondWrapper]}></Box>
            </Box>

            <Box sx={spacingTop}>
              <Button
                variant="contained"
                startIcon={<SaveIcon />}
                type="submit"
                disabled={isInputStok === true ? false : true}
              >
                Simpan Transaksi
              </Button>
            </Box>
          </Card.Body>
        </Card>
      </Form>

      <Box sx={tableChildWrapper}>
        <TableContainer component={Paper} sx={{ width: "100%" }}>
          <Table aria-label="simple table">
            <TableHead className={classes.root}>
              <TableRow>
                <TableCell
                  sx={{ fontWeight: "bold", textAlign: "center" }}
                  className={classes.tableRightBorder}
                >
                  Kode
                </TableCell>
                <TableCell
                  sx={{ fontWeight: "bold", textAlign: "center" }}
                  className={classes.tableRightBorder}
                >
                  Nama Stok
                </TableCell>
                <TableCell
                  sx={{ fontWeight: "bold", textAlign: "center" }}
                  className={classes.tableRightBorder}
                >
                  Qty.
                </TableCell>
                <TableCell
                  sx={{ fontWeight: "bold", textAlign: "center" }}
                  className={classes.tableRightBorder}
                >
                  Sat.
                </TableCell>
                <TableCell
                  sx={{ fontWeight: "bold", textAlign: "center" }}
                  className={classes.tableRightBorder}
                >
                  Harga
                </TableCell>
                <TableCell
                  sx={{ fontWeight: "bold", textAlign: "center" }}
                  className={classes.tableRightBorder}
                >
                  D1 (%)
                </TableCell>
                <TableCell
                  sx={{ fontWeight: "bold", textAlign: "center" }}
                  className={classes.tableRightBorder}
                >
                  Pot1 (Rp)
                </TableCell>
                <TableCell
                  sx={{ fontWeight: "bold", textAlign: "center" }}
                  className={classes.tableRightBorder}
                >
                  D2 (%)
                </TableCell>
                <TableCell
                  sx={{ fontWeight: "bold", textAlign: "center" }}
                  className={classes.tableRightBorder}
                >
                  Pot2 (Rp)
                </TableCell>
                <TableCell
                  sx={{ fontWeight: "bold", textAlign: "center" }}
                  className={classes.tableRightBorder}
                >
                  Total Rp.
                </TableCell>
                <TableCell
                  sx={{ fontWeight: "bold", textAlign: "center" }}
                  className={classes.tableRightBorder}
                >
                  Aksi
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {pembelianChilds.map((user, index) => (
                <TableRow
                  key={user.id}
                  sx={{
                    "&:last-child td, &:last-child th": { border: 0 },
                    "&:hover": { bgcolor: Colors.grey300 },
                  }}
                >
                  <TableCell component="th" scope="row">
                    {user.stok.kodeStok}
                  </TableCell>
                  <TableCell>{user.stok.namaStok}</TableCell>
                  <TableCell align="right">
                    {user.quantity.toLocaleString("de-DE")}
                    {/* <NumericFormat
                      value={user.quantity}
                      decimalSeparator={","}
                      thousandSeparator={"."}
                      customInput={Form.Control}
                      onValueChange={(values) => {
                        user.quantity = values.formattedValue
                          .split(".")
                          .join("")
                          .replace(/,/g, "");
                      }}
                    /> */}
                  </TableCell>
                  <TableCell>{user.stok.satuanKecilStok}</TableCell>
                  <TableCell align="right">
                    {user.hargaNetto.toLocaleString("de-DE")}
                    {/* <NumericFormat
                      value={user.hargaNetto}
                      decimalSeparator={","}
                      thousandSeparator={"."}
                      customInput={Form.Control}
                      onValueChange={(values) => {
                        user.hargaNetto = values.formattedValue
                          .split(".")
                          .join("")
                          .replace(/,/g, "");
                      }}
                    /> */}
                  </TableCell>
                  <TableCell align="right">
                    {user.discountPersen1.toLocaleString("de-DE")}
                    {/* <NumericFormat
                      value={user.discountPersen1}
                      decimalSeparator={","}
                      thousandSeparator={"."}
                      customInput={Form.Control}
                      onValueChange={(values) => {
                        user.discountPersen1 = values.formattedValue
                          .split(".")
                          .join("")
                          .replace(/,/g, "");
                      }}
                    /> */}
                  </TableCell>
                  <TableCell align="right">
                    {user.discount1.toLocaleString("de-DE")}
                    {/* <NumericFormat
                      value={user.discount1}
                      decimalSeparator={","}
                      thousandSeparator={"."}
                      customInput={Form.Control}
                      onValueChange={(values) => {
                        user.discount1 = values.formattedValue
                          .split(".")
                          .join("")
                          .replace(/,/g, "");
                      }}
                    /> */}
                  </TableCell>
                  <TableCell align="right">
                    {user.discountPersen2.toLocaleString("de-DE")}
                    {/* <NumericFormat
                      value={user.discountPersen2}
                      decimalSeparator={","}
                      thousandSeparator={"."}
                      customInput={Form.Control}
                      onValueChange={(values) => {
                        user.discountPersen2 = values.formattedValue
                          .split(".")
                          .join("")
                          .replace(/,/g, "");
                      }}
                    /> */}
                  </TableCell>
                  <TableCell align="right">
                    {user.discount2.toLocaleString("de-DE")}
                    {/* <NumericFormat
                      value={user.discount2}
                      decimalSeparator={","}
                      thousandSeparator={"."}
                      customInput={Form.Control}
                      onValueChange={(values) => {
                        user.discount2 = values.formattedValue
                          .split(".")
                          .join("")
                          .replace(/,/g, "");
                      }}
                    /> */}
                  </TableCell>
                  <TableCell align="right">
                    {user.totalPembelianChild.toLocaleString("de-DE")}
                  </TableCell>
                  <TableCell>
                    <ButtonGroup variant="contained">
                      <Button
                        sx={{ textTransform: "none" }}
                        onClick={(e) => {
                          handleClickOpenUbah(e);
                          setIdPembelianChild(user.id);
                          setKodeStok(user.stok.kodeStok);
                          setNamaStok(user.stok.namaStok);
                          setQuantity(user.quantity);
                          setHargaSatuan(user.hargaSatuan);
                          setDiscountPersen1(user.discountPersen1);
                          setDiscount1(user.discount1);
                          setDiscountPersen2(user.discountPersen2);
                          setDiscount2(user.discount2);
                          setHargaNetto(user.hargaNetto);
                          setTotalPembelianChild(user.totalPembelianChild);
                        }}
                      >
                        <EditIcon />
                      </Button>
                      <Button
                        color="error"
                        sx={{ textTransform: "none" }}
                        onClick={(e) => {
                          deletePembelianChild(
                            e,
                            user.id,
                            user.totalPembelianChild
                          );
                        }}
                      >
                        <DeleteOutlineIcon />
                      </Button>
                    </ButtonGroup>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>

      <Form noValidate validated={validated} onSubmit={savePembelianTotal}>
        <Card style={{ marginTop: 10 }}>
          <Card.Header>Data Total</Card.Header>
          <Card.Body>
            <Box sx={textFieldContainer}>
              <Box sx={textFieldWrapper}>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Subtotal :
                      </Form.Label>
                      <Col sm="7">
                        <NumericFormat
                          disabled
                          value={subtotal}
                          decimalSeparator={","}
                          thousandSeparator={"."}
                          customInput={Form.Control}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Potongan <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="7">
                        <NumericFormat
                          required
                          value={potongan}
                          decimalSeparator={","}
                          thousandSeparator={"."}
                          customInput={Form.Control}
                          onValueChange={(values) => {
                            let tempValue = values.formattedValue
                              .split(".")
                              .join("")
                              .replace(/,/g, "");
                            setPotongan(tempValue);

                            let tempPpnTotal = 0;

                            if (isPpn) {
                              tempPpnTotal =
                                ((parseFloat(subtotal) -
                                  parseFloat(tempValue)) *
                                  parseFloat(ppnPersen)) /
                                100;
                              setPpnTotal(tempPpnTotal);
                            } else {
                              setPpnTotal(tempPpnTotal);
                            }

                            let tempTotal =
                              parseFloat(subtotal) -
                              parseFloat(tempValue) +
                              parseFloat(tempPpnTotal);
                            setTotal(tempTotal);
                          }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        PPN ({setting.ppnPersen}) <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="2">
                        <FormControlLabel
                          control={<Checkbox checked={isPpn} />}
                          onChange={() => {
                            setIsPpn(!isPpn);

                            if (!isPpn) {
                              setPpnPersen(setting.ppnPersen);
                              let tempPpnTotal =
                                ((parseFloat(subtotal) - parseFloat(potongan)) *
                                  parseFloat(setting.ppnPersen)) /
                                100;
                              setPpnTotal(tempPpnTotal);

                              let tempTotal =
                                parseFloat(subtotal) -
                                parseFloat(potongan) +
                                parseFloat(tempPpnTotal);
                              setTotal(tempTotal);
                            } else {
                              setPpnPersen(0);
                              setPpnTotal(0);

                              let tempTotal =
                                parseFloat(subtotal) - parseFloat(potongan);
                              setTotal(tempTotal);
                            }
                          }}
                        />
                      </Col>
                      <Col sm="5">
                        <NumericFormat
                          value={ppnTotal}
                          decimalSeparator={","}
                          thousandSeparator={"."}
                          customInput={Form.Control}
                          disabled
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Total :
                      </Form.Label>
                      <Col sm="7">
                        <NumericFormat
                          disabled
                          value={total}
                          decimalSeparator={","}
                          thousandSeparator={"."}
                          customInput={Form.Control}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
              </Box>
              <Box sx={[textFieldWrapper, secondWrapper]}></Box>
            </Box>
          </Card.Body>
        </Card>

        <Box sx={spacingTop}>
          <Button
            variant="outlined"
            color="secondary"
            onClick={() => navigate("/daftarPembelian")}
            sx={{ marginRight: 2 }}
          >
            {"< Kembali"}
          </Button>
          <Button
            variant="contained"
            startIcon={<SaveIcon />}
            type="submit"
            disabled={pembelianId === null && true}
          >
            Simpan
          </Button>
        </Box>
      </Form>
      {error && (
        <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
          <Alert onClose={handleClose} severity="error" sx={alertBox}>
            Data belum terisi semua!
          </Alert>
        </Snackbar>
      )}

      <Dialog
        open={openSupplier}
        onClose={handleCloseSupplier}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{`Pilih Data Supplier`}</DialogTitle>
        <DialogActions>
          <Box sx={dialogContainer}>
            <Form onSubmit={searchData}>
              <Box sx={searchBarContainer}>
                <SearchBar value={query} setSearchTerm={setQuery} />
                <Button
                  variant="contained"
                  type="submit"
                  color="primary"
                  disableElevation
                >
                  Cari
                </Button>
              </Box>
            </Form>
            <TableContainer component={Paper} sx={dialogWrapper}>
              <Table aria-label="simple table">
                <TableHead className={classes.root}>
                  <TableRow>
                    <TableCell
                      sx={{ fontWeight: "bold", textAlign: "center" }}
                      className={classes.tableRightBorder}
                    >
                      Kode
                    </TableCell>
                    <TableCell
                      sx={{ fontWeight: "bold", textAlign: "center" }}
                      className={classes.tableRightBorder}
                    >
                      Nama
                    </TableCell>
                    <TableCell
                      sx={{ fontWeight: "bold", textAlign: "center" }}
                      className={classes.tableRightBorder}
                    >
                      Alamat
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {suppliers.map((supplier, index) => (
                    <TableRow
                      key={supplier._id}
                      sx={{
                        "&:last-child td, &:last-child th": { border: 0 },
                        "&:hover": { bgcolor: Colors.grey300 },
                        cursor: "pointer",
                      }}
                      onClick={async () => {
                        setKodeSupplier(supplier.kodeSupplier);
                        setNamaSupplier(supplier.namaSupplier);
                        setAlamatSupplier(supplier.alamatSupplier);

                        handleCloseSupplier();
                      }}
                    >
                      <TableCell component="th" scope="row">
                        {supplier.kodeSupplier}
                      </TableCell>
                      <TableCell>{supplier.namaSupplier}</TableCell>
                      <TableCell>{supplier.alamatSupplier}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            <Box sx={tableContainer}>
              <Pagination
                count={pages}
                page={page + 1}
                onChange={handleChange}
                color="primary"
                size={screenSize <= 600 ? "small" : "large"}
              />
            </Box>
          </Box>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openStok}
        onClose={handleCloseStok}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{`Pilih Data Stok`}</DialogTitle>
        <DialogActions>
          <Box sx={dialogContainer}>
            <Form onSubmit={searchDataStok}>
              <Box sx={searchBarContainer}>
                <SearchBar value={queryStok} setSearchTerm={setQueryStok} />
                <Button
                  variant="contained"
                  type="submit"
                  color="primary"
                  disableElevation
                >
                  Cari
                </Button>
              </Box>
            </Form>
            <TableContainer component={Paper} sx={dialogWrapper}>
              <Table aria-label="simple table">
                <TableHead className={classes.root}>
                  <TableRow>
                    <TableCell
                      sx={{ fontWeight: "bold", textAlign: "center" }}
                      className={classes.tableRightBorder}
                    >
                      Kode
                    </TableCell>
                    <TableCell
                      sx={{ fontWeight: "bold", textAlign: "center" }}
                      className={classes.tableRightBorder}
                    >
                      Nama
                    </TableCell>
                    <TableCell
                      sx={{ fontWeight: "bold", textAlign: "center" }}
                      className={classes.tableRightBorder}
                    >
                      Satuan
                    </TableCell>
                    <TableCell
                      sx={{ fontWeight: "bold", textAlign: "center" }}
                      className={classes.tableRightBorder}
                    >
                      Sisa
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {stoks.map((stok, index) => (
                    <TableRow
                      key={stok._id}
                      sx={{
                        "&:last-child td, &:last-child th": { border: 0 },
                        "&:hover": { bgcolor: Colors.grey300 },
                        cursor: "pointer",
                      }}
                      onClick={async () => {
                        setPilihStok(stok.kodeStok);
                        setKodeStok(stok.kodeStok);
                        setNamaStok(stok.namaStok);
                        setQuantity("0");
                        setHargaSatuan("0");
                        setDiscountPersen1("0");
                        setDiscount1("0");
                        setDiscountPersen2("0");
                        setDiscount2("0");
                        setHargaNetto("0");
                        setTotalPembelianChild("0");

                        handleCloseStok();
                      }}
                    >
                      <TableCell component="th" scope="row">
                        {stok.kodeStok}
                      </TableCell>
                      <TableCell>{stok.namaStok}</TableCell>
                      <TableCell>{stok.satuanKecilStok}</TableCell>
                      <TableCell>-</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            <Box sx={tableContainer}>
              <Pagination
                count={pagesStok}
                page={pageStok + 1}
                onChange={handleChangeStok}
                color="primary"
                size={screenSize <= 600 ? "small" : "large"}
              />
            </Box>
          </Box>
        </DialogActions>
      </Dialog>
      <Dialog
        onClose={handleCloseUbah}
        aria-labelledby="customized-dialog-title"
        open={openUbah}
        fullWidth={true}
        maxWidth={"sm"}
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
          Ubah Barang Pembelian
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleCloseUbah}
          sx={(theme) => ({
            position: "absolute",
            right: 8,
            top: 8,
            color: theme.palette.grey[500],
          })}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent
          dividers
          //  sx={{ height: "200px" }}
        >
          <div>
            <Row>
              <Col>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="5" style={textRight}>
                    Kode / Barcode :
                  </Form.Label>
                  <Col sm="7">
                    <Form.Control disabled value={pilihStok} />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="5" style={textRight}>
                    Nama Stok :
                  </Form.Label>
                  <Col sm="7">
                    <Form.Control disabled value={namaStok} />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="5" style={textRight}>
                    Quantity <b style={colorRed}>*</b> :
                  </Form.Label>
                  <Col sm="7">
                    <NumericFormat
                      required
                      value={quantity}
                      decimalSeparator={","}
                      thousandSeparator={"."}
                      customInput={Form.Control}
                      onValueChange={(values) => {
                        let tempValue = values.formattedValue
                          .split(".")
                          .join("")
                          .replace(/,/g, "");
                        setQuantity(tempValue);

                        let tempHargaNetto =
                          parseFloat(hargaSatuan) -
                          parseFloat(discount1) -
                          parseFloat(discount2);
                        setHargaNetto(tempHargaNetto);

                        let tempTotalPembelianChild =
                          parseFloat(tempValue) * parseFloat(tempHargaNetto);
                        setTotalPembelianChild(tempTotalPembelianChild);
                      }}
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="5" style={textRight}>
                    Harga Satuan <b style={colorRed}>*</b> :
                  </Form.Label>
                  <Col sm="7">
                    <NumericFormat
                      required
                      value={hargaSatuan}
                      decimalSeparator={","}
                      thousandSeparator={"."}
                      customInput={Form.Control}
                      onValueChange={(values) => {
                        let tempValue = values.formattedValue
                          .split(".")
                          .join("")
                          .replace(/,/g, "");
                        setHargaSatuan(tempValue);

                        let tempHargaNetto =
                          parseFloat(tempValue) -
                          parseFloat(discount1) -
                          parseFloat(discount2);
                        setHargaNetto(tempHargaNetto);

                        let tempTotalPembelianChild =
                          parseFloat(quantity) * parseFloat(tempHargaNetto);
                        setTotalPembelianChild(tempTotalPembelianChild);

                        let tempDiscount1 =
                          (parseFloat(tempValue) * discountPersen1) / 100;
                        setDiscount1(tempDiscount1);

                        let tempDiscount2 =
                          ((parseFloat(tempValue) - parseFloat(tempDiscount1)) *
                            discountPersen2) /
                          100;
                        setDiscount2(tempDiscount2);
                      }}
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="5" style={textRight}>
                    Disc / Pot. 1 <b style={colorRed}>*</b> :
                  </Form.Label>
                  <Col sm="3">
                    <NumericFormat
                      required
                      value={discountPersen1}
                      decimalSeparator={","}
                      thousandSeparator={"."}
                      customInput={Form.Control}
                      onValueChange={(values, sourceInfo) => {
                        if (sourceInfo.source !== "event") return;

                        let tempValue = values.formattedValue;
                        setDiscountPersen1(tempValue);

                        let tempDiscount1 =
                          (parseFloat(hargaSatuan) * tempValue) / 100;
                        setDiscount1(tempDiscount1);

                        let temHargaNetto =
                          parseFloat(hargaSatuan) - parseFloat(tempDiscount1);
                        setHargaNetto(temHargaNetto);

                        let tempTotalPembelianChild =
                          parseFloat(quantity) * parseFloat(temHargaNetto);
                        setTotalPembelianChild(tempTotalPembelianChild);

                        let tempDiscount2 =
                          ((parseFloat(hargaSatuan) -
                            parseFloat(tempDiscount1)) *
                            discountPersen2) /
                          100;
                        setDiscount2(tempDiscount2);
                      }}
                    />
                  </Col>
                  <Col sm="4">
                    <NumericFormat
                      required
                      value={discount1}
                      decimalSeparator={","}
                      thousandSeparator={"."}
                      customInput={Form.Control}
                      onValueChange={(values, sourceInfo) => {
                        if (sourceInfo.source !== "event") return;
                        let tempValue = values.formattedValue
                          .split(".")
                          .join("")
                          .replace(/,/g, "");
                        setDiscount1(tempValue);

                        let tempDiscountPersen1 =
                          (parseFloat(tempValue) / parseFloat(hargaSatuan)) *
                          100;
                        // limit to 2 decimals
                        tempDiscountPersen1 = Number(
                          tempDiscountPersen1.toFixed(2)
                        );
                        setDiscountPersen1(tempDiscountPersen1);

                        let temHargaNetto =
                          parseFloat(hargaSatuan) - parseFloat(tempValue);
                        setHargaNetto(temHargaNetto);

                        let tempTotalPembelianChild =
                          parseFloat(quantity) * parseFloat(temHargaNetto);
                        setTotalPembelianChild(tempTotalPembelianChild);
                      }}
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="5" style={textRight}>
                    Disc / Pot. 2 <b style={colorRed}>*</b> :
                  </Form.Label>
                  <Col sm="3">
                    <NumericFormat
                      required
                      value={discountPersen2}
                      decimalSeparator={","}
                      thousandSeparator={"."}
                      customInput={Form.Control}
                      onValueChange={(values, sourceInfo) => {
                        if (sourceInfo.source !== "event") return;

                        let tempValue = values.formattedValue;
                        setDiscountPersen2(tempValue);

                        let tempDiscount2 =
                          ((parseFloat(hargaSatuan) - parseFloat(discount1)) *
                            tempValue) /
                          100;
                        setDiscount2(tempDiscount2);

                        let temHargaNetto =
                          parseFloat(hargaSatuan) -
                          parseFloat(discount1) -
                          parseFloat(tempDiscount2);
                        setHargaNetto(temHargaNetto);

                        let tempTotalPembelianChild =
                          parseFloat(quantity) * parseFloat(temHargaNetto);
                        setTotalPembelianChild(tempTotalPembelianChild);
                      }}
                    />
                  </Col>
                  <Col sm="4">
                    <NumericFormat
                      required
                      value={discount2}
                      decimalSeparator={","}
                      thousandSeparator={"."}
                      customInput={Form.Control}
                      onValueChange={(values, sourceInfo) => {
                        if (sourceInfo.source !== "event") return;
                        let tempValue = values.formattedValue
                          .split(".")
                          .join("")
                          .replace(/,/g, "");
                        setDiscount2(tempValue);

                        let tempDiscountPersen2 =
                          (parseFloat(tempValue) /
                            (parseFloat(hargaSatuan) - parseFloat(discount1))) *
                          100;
                        // limit to 2 decimals
                        tempDiscountPersen2 = Number(
                          tempDiscountPersen2.toFixed(2)
                        );
                        setDiscountPersen2(tempDiscountPersen2);

                        let temHargaNetto =
                          parseFloat(hargaSatuan) -
                          parseFloat(discount1) -
                          parseFloat(tempValue);
                        setHargaNetto(temHargaNetto);

                        let tempTotalPembelianChild =
                          parseFloat(quantity) * parseFloat(temHargaNetto);
                        setTotalPembelianChild(tempTotalPembelianChild);
                      }}
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="5" style={textRight}>
                    Harga Netto :
                  </Form.Label>
                  <Col sm="7">
                    <NumericFormat
                      disabled
                      value={hargaNetto}
                      decimalSeparator={","}
                      thousandSeparator={"."}
                      customInput={Form.Control}
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="5" style={textRight}>
                    Total :
                  </Form.Label>
                  <Col sm="7">
                    <NumericFormat
                      disabled
                      value={totalPembelianChild}
                      decimalSeparator={","}
                      thousandSeparator={"."}
                      customInput={Form.Control}
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
          </div>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            startIcon={<SaveIcon />}
            onClick={updatePembelianChild}
          >
            Simpan
          </Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
};

export default TambahPembelian;

const spacingTop = {
  mt: 4,
};

const alertBox = {
  width: "100%",
};

const subTitleText = {
  fontWeight: "900",
};

const dialogContainer = {
  display: "flex",
  flexDirection: "column",
  width: "800px",
};

const dialogWrapper = {
  width: "100%",
  marginTop: 2,
};

const colorRed = {
  color: "red",
};

const tableContainer = {
  pt: 4,
  display: "flex",
  justifyContent: "center",
};

const searchBarContainer = {
  pt: 6,
  display: "flex",
  justifyContent: "center",
};

const textFieldContainer = {
  display: "flex",
  flexDirection: {
    xs: "column",
    sm: "row",
  },
};

const textFieldWrapper = {
  display: "flex",
  flex: 1,
  flexDirection: "column",
  maxWidth: {
    md: "40vw",
  },
};

const secondWrapper = {
  marginLeft: {
    sm: 4,
  },
  marginTop: {
    sm: 0,
    xs: 4,
  },
};

const tableChildWrapper = {
  mt: 4,
  height: "400px",
  overflowY: "auto",
  border: "1px solid #e0e0e0",
};
